var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2049 3.51769L15.1569 6.46971M2.36486 13.3577L1.38086 17.2937L5.31687 16.3097L16.7175 4.90908C17.0865 4.54002 17.2937 4.03954 17.2937 3.51769C17.2937 2.99585 17.0865 2.49537 16.7175 2.12631L16.5483 1.95707C16.1792 1.58812 15.6788 1.38086 15.1569 1.38086C14.6351 1.38086 14.1346 1.58812 13.7655 1.95707L2.36486 13.3577Z",
    stroke: "#191E31",
    strokeWidth: 1.47619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/editPencil.4427b9fa448106cbddc8f31817b23a4c.svg";
export { ForwardRef as ReactComponent };